import React, { useState } from "react";

export default function LabTest({ data }) {
  const lots = data?.lots || [];

  const [selectedLot, setSelectedLot] = useState("");
  const [moisture, setMoisture] = useState("");
  const [quality, setQuality] = useState("");

  return (
    <div>
      <h2 className="text-xl text-yellow-200 mb-4">Lab Testing</h2>

      {/* SELECT LOT */}
      <select
        value={selectedLot}
        onChange={(e) => setSelectedLot(e.target.value)}
        className="p-2 text-black mb-3 w-full"
      >
        <option value="">Select Lot</option>
        {lots.map((lot) => (
          <option key={lot.id} value={lot.id}>
            {lot.id} - {lot.crop}
          </option>
        ))}
      </select>

      {/* INPUTS */}
      <input
        type="number"
        placeholder="Moisture (%)"
        value={moisture}
        onChange={(e) => setMoisture(e.target.value)}
        className="p-2 text-black mb-2 w-full"
      />

      <input
        type="text"
        placeholder="Quality Notes"
        value={quality}
        onChange={(e) => setQuality(e.target.value)}
        className="p-2 text-black mb-2 w-full"
      />

      <button className="bg-blue-600 px-4 py-2 rounded">
        Save Test Report
      </button>

      {/* RESULT CARD */}
      {selectedLot && (
        <div className="mt-4 bg-gray-800 p-3 rounded">
          <p>Lot: {selectedLot}</p>
          <p>Moisture: {moisture || "-"}%</p>
          <p>Notes: {quality || "-"}</p>
        </div>
      )}
    </div>
  );
}